/**
 * Diese Klasse enthält die effektiven Datadictionary-Metadaten
 * für einen bestimmten Metadatenschlüssel und einen bestimmten Kontext.
 * Über die Konfigurationsquellen wurde schon gemergt.
 */
export class DdEntryMerged {
    public active?: boolean; // wenn 'false' zählt das Feld als deaktiviert, keine Validierungen finden statt und beim Speichern wird das Feld geleert
    public identifier: string; // Identifier für das Data-Dictionary und für das Label
    public labeltextIdentifier?: string; // Optionaler Identifier für das Label, der vorrangig verwendet wird
    public helptextIdentifier?: string;  // Identifier für den Hilfetext
    public defaultValue?: string; // Definition eines Standardwertes
    public readonly?: boolean; // Darf Attribut nur gelesen werden?
    public _hidden?: boolean; // Soll Attribut versteckt werden?
    public required?: boolean; // handelt es sich um ein Pflichtfeld?
    public minValueInteger?: number; // Definiert einen Mindestwert
    public maxValueInteger?: number; // Definiert einen Maximalwert
    public minValueDouble?: number; // Definiert einen Mindestwert
    public maxValueDouble?: number; // Definiert einen Maximalwert
    // Definiert einen Mindestwert - als ISO-String oder als number in Millisekunden seit 1970-01-01 00:00:00 UTC
    public minValueDate?: string | number;
    // Definiert einen Maximalwert - als ISO-String oder als number in Millisekunden seit 1970-01-01 00:00:00 UTC
    public maxValueDate?: string | number;
    public minLength?: number; // Minimallänge (für Strings)
    public maxLength?: number; // Maximallänge (für Strings)
    public datatype?: string; // Spezielle Validierungen einschalten
    public regexPattern?: string; // Definiert einen regulären Ausdruck zur Überprüfung
    public regexErrortextIdentifier?: string; // Identifier für die Fehlermeldung des Regexpatterns
    public validationMethod?: string; // Methode zum individuellen Validieren
    public validationMethodErrortextIdentifier?: string; // Identifier für die Fehlermeldung der Validierungsmethode
    public backendErrorIdentifier?: boolean; // Gibt es einen BackendError?
    public dataSourceFilter?: string; // Filter für Auswahlfelder - Format 'hiskeyIds: 1001,1004'; || objGuids: c93bc42b-ba6d-48c4-9047-8a0bb6a69d92,a798722d-b1fa-4f19-8238-1845f1938cfc'

    // Namen der Konfigurationsquellen (z.B. 'HIS', 'CUST'), die für diesen Kontext eine explizite Konfiguration
    // beisteuern - sortiert nach aufsteigender confsrc-Priorität. undefined/leer, falls keine explizite Konfiguration existiert.
    public confSrcs?: string[];

    // all defined boolean properties of this class DdEntryMerged.
    // boolean properties with value false or undefined ware not mapped to instance of object.
    // This is unfavorable while merging DD-Entry with differnet context within
    // "#HisDdService.getMergedEntry()" when false or undefined actually should ovrride property
    public static allDdBooleanAttributes: string[] =
        Object.getOwnPropertyNames( { _hidden: null, required: null, readonly: null, backendErrorIdentifier: null } as DdEntryMerged );

    get hidden(): boolean {
        return this._hidden || this.active === false;
    }
        
    set hidden( hidden: boolean | undefined ) {
        this._hidden = hidden;
    }

}


/**
 * Eine Map von Kontexten auf die jeweiligen Metadaten.
 */
export class DdContextEntriesMap {
    [context: string]: DdEntryMerged;
}

/**
 * Das gesamte DataDictionary ist eine Map von keys auf (Maps von Kontexten auf die jeweiligen Metadaten)
 */
export class DataDictionary {
    [key: string]: DdContextEntriesMap;
}
